import { clearOldLocationPageInteractionsEntries, trackRoomClicked } from '@/services/location-page-interactions-tracker';

export const trackFormChange = (label, value) => {
  App.track.all({
    category: 's-tag-page',
    action: `search-field-change--${label}`,
    label: value,
  });
};

const trackScrollToRoomCards = ($roomBoxes) => {
  if ($roomBoxes.length === 0 || !window.IntersectionObserver) {
    return; // LP with no room cards - it happens
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        App.track.event('location_page_interaction', {
          section: 'room_cards',
          element: 'first_room_card',
          interaction: 'visible',
        });
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 1, // whole first room card visible
  });

  // observe first room card
  observer.observe($roomBoxes[0]);
};

export const init = () => {
  const $roomBoxes = $('.c-room-card');
  const tagSlug = $('[name="room_tag"]').val();

  const visibleRooms = $roomBoxes.map((i, element) => $(element).data('id')).toArray();

  const visibilityTracker = App.components.page_visibility_tracker().init();

  App.es6.shared.track_click(
    $roomBoxes,
    (e) => {
      const $target = $(e.currentTarget).parents('.c-room-card');
      const $targetCarousel = $target.find('.lory-slider');

      const roomId = $target.data('id');
      const venueId = $target.data('venue-id');
      const position = +($targetCarousel.data('index') ?? 0) + 1;
      const totalPhotos = +($targetCarousel.data('photos-count') ?? 0);
      const isFeatured = !!$targetCarousel.data('featured');

      const isCTAbutton = e.target?.classList?.contains('c-room-card___check-availability') || false;
      const isCTALink = e.target?.classList?.contains('check-availability') || false;

      const $img = $target.findOne('.lory-slide.active img, .c-room-card__img_single');

      App.track.roomCardClick({
        roomId,
        context: 'hire',
        tagSlug,
        page: 1,
        position,
        photoIndex: (+($img.data('index') ?? 0)) + 1,
        photoUrl: $img.attr('src'),
        totalPhotos,
      });

      App.track.event('clicked_to_room_page', {
        room_id: roomId,
        venue_id: venueId,
        position,

        section: 'location_page_listing',
        element: isCTAbutton || isCTALink ? 'check_availability_CTA_v1' : 'room_tile',
        element_value: roomId,

        interaction: 'click',
      });

      App.es6.shared.sessionFlash.flash({
        position,
        page: 1,
        isFeatured,
      }, `flash-room-${roomId}`);

      if (visibilityTracker) {
        visibilityTracker.addRoomClicked(roomId);
      }

      trackRoomClicked(roomId);

      clearOldLocationPageInteractionsEntries();
    },
  );

  /*
   Data tracking page seen rooms & time
   */
  (() => {
    if (!visibilityTracker) {
      return;
    }

    visibilityTracker.observe($('.c-room-card'));

    const timeTrackingWatch = App.components.stop_watch();
    timeTrackingWatch.init();
    timeTrackingWatch.start();

    const submitSeenRooms = () => {
      const seen = visibilityTracker.getDisplayedRooms();
      const seenDuration = visibilityTracker.getDisplayedRoomsDurations();
      const clicked = visibilityTracker.getClickedRooms();

      if (seen.length === 0 && clicked.length === 0) {
        return;
      }

      timeTrackingWatch.stop();
      const { startTime, duration, currentTime } = timeTrackingWatch.getTimes();

      App.track.custom(window.__DATA_TRACKING_SEEN_ROOMS, {
        seen: seen.join(', '),
        timeSeen: seenDuration.join(', '),
        clicked: clicked.join(', '),
        tagSlug,
        timeVisited: startTime,
        timeExited: currentTime,
        landingLocationPage: Number(App.es6.shared.cookie.get('tgv_landing_location_page')) || null,
        duration,
      });
    };

    window.addEventListener('beforeunload', () => submitSeenRooms());
    window.addEventListener('focus', () => timeTrackingWatch.start());
    window.addEventListener('blur', () => timeTrackingWatch.stop());

    $('.c-box-carousel').on('click', '.c-room-card', function onCLick() {
      trackRoomClicked(+this.dataset.id);
    });
  })();

  // Data-tracking page visit
  App.track.custom(window.__DATA_TRACKING_FRONT_TAGPAGE_VISITED, {
    roomIds: visibleRooms.join(','),
    tagSlug,
    referrer: document.referrer,
  });

  trackScrollToRoomCards($roomBoxes);
};

export const onBeforeSlide = (e) => {
  const tagSlug = $('[name="room_tag"]').val();
  const $target = $(e.target);
  const roomId = $target.data('room-id');

  // ignore event if it's not room carousel
  if (!roomId) {
    return;
  }
  const position = +$target.data('index') + 1;
  const totalPhotos = +$target.data('photos-count');

  const $img = $(e.target).find('.lory-slide.active img');
  const arrowDirection = e.detail.nextSlide > e.detail.index ? 'right' : 'left';

  const $imgNext = $(e.target)
    .find('.lory-slide.active')[arrowDirection === 'left' ? 'prev' : 'next']().find('img');

  // if src was not yet set by lazy loading use data-src
  const photoUrlAfter = $imgNext.attr('src') || $imgNext.data('src');

  App.track.roomCardCarouselArrowClick({
    roomId,
    context: 'hire',
    tagSlug,
    position,
    page: 1,
    photoIndex: $img.data('index') + 1,
    photoUrl: $img.attr('src'),
    totalPhotos,
    arrowDirection,
    photoUrlAfter,
  });
};
